import styled, {keyframes} from 'styled-components';

const BorderAnimationIn = keyframes`
    0% {
        width: 0%;
    } 100% {
        width: 100%;
    }
`;

const BorderAnimationOut = keyframes`
    0% {
        width: 100%;
    } 100% {
        width: 0%;
    }
`;

export const Wrapper = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    position: fixed;
    z-index: 5;
    background: white;
    border-bottom: 1px solid lightgrey;
    transform: ${({hide}) => hide};
    animation-timing-function: ease-in-out;
    animation-duration: 2s;
    margin: 0 auto;
    &:before, :after {
        box-sizing: border-box;
        -webkit-font-smoothing: antialiased;
    }
    @media screen nad (max-width: 768px) {
        padding: 10px;
    }
`;

export const Content = styled.div`
    width: 30%;
    max-width: var(--maxWidth);
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    margin: 40px auto;
    a {
        text-decoration: none;
        color: var(--black);
        margin: 0;
        padding: 0;
    }
    @media screen and (max-width: 900px) {
        display: none;
    }
`;

export const LinkButton = styled.div`
    @media screen and (max-width: 900px) {
        color: var(--white);
        align-self: left;
    }
    div {
        width: 0%;
        color: var(--black);
        height: 2px;
        margin: 0 auto;
        animation: ${BorderAnimationOut} 0.5s ease-out;
        &:hover {
            animation: ${BorderAnimationIn} 0.5s ease-in;
        }
    }
`;

export const Logo = styled.img`
    display: flex;
    flex-direction: row;
    align-self: left;
    margin: 0 auto;
    height: auto;
    @media screen and (max-width: 768px) {
        margin: 5px 40px;
    }
`;

export const MobileMenu = styled.div`
    display: none;
    flex-direction: column;
    justify-content: center;
    background: #222020;
    color: white;
    transform: ${({ open }) => open ? 'translateX(0)' : 'translateX(-100%)'};
    height: 100vh;
    padding: 20rem 2rem;
    position: absolute;
    top: 0;
    left: 0;
    transition: transform 0.3s ease-in-out;
    width: 100%;
    @media screen and (max-width: 900px) {
        display: flex;
    }

    a {
        font-size: 2rem;
        text-transform: uppercase;
        padding: 2rem 0;
        font-weight: bold;
        letter-spacing: 0.5rem;
        text-decoration: none;
        transition: color 0.3s linear;
    }

    &:hover {
      color: #343078;
    }
`;

export const Burger = styled.div`
    display: none;
    flex-direction: column;
    justify-content: space-around;
    width: 3rem;
    height: 3rem;
    background: transparent;
    border: none;
    cursor: pointer;
    margin: 10px 30px;
    padding: 0;
    z-index: 5;

    @media screen and (max-width: 900px) {
        display: flex;
    }

    &:focus {
        outline: none;
    }

    div {
        width: 3rem;
        margin: 2px 0;
        height: 0.30rem;
        background: ${({ open }) => open ? 'white' : 'black'};
        transition: all 0.3s linear;
        position: relative;
        transform-origin: 1px;

    &:first-child {
        transform: ${({ open }) => open ? 'rotate(45deg)' : 'rotate(0)'};
    }

    &:nth-child(2) {
        opacity: ${({ open }) => open ? '0' : '1'};
        transform: ${({ open }) => open ? 'translateX(20px)' : 'translateX(0)'};
    }

    &:nth-child(3) {
        transform: ${({ open }) => open ? 'rotate(-45deg)' : 'rotate(0)'};
    }
  }
`;

export const Icon = styled.img`
    width: 100%;
    height: auto;
`;
